// removed by extract-text-webpack-plugin
module.exports = {"trendIcon":"route-trendIcon--241sU","status-ok":"route-status-ok--1vePw","status-warning":"route-status-warning--1Alhs","status-problem":"route-status-problem--12z06","status-disconnected":"route-status-disconnected--kIr3f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataPanel/Details/Route/route.scss
// module id = W6I0
// module chunks = 4